import WarningAlertIcon from '../../../../../images/warning_alert_outline_yellow.svg';
import { Colors } from '../../../../../themes/colors';
import CustomPortal from '../../../../commonComponents/CustomPortal';

export const ConfirmationPopup = ({ controls, isSubmitting, onConfirm }) => (
  <CustomPortal
    Icon={WarningAlertIcon}
    cancelText="Go Back"
    containerStyle={{ paddingInline: 50, paddingTop: 30 }} // Optional
    rightButtonDisabled={isSubmitting}
    submitText="Post Job"
    textStyle={{ textAlign: 'center' }}
    title="Before You Continue"
    cancelPressed={controls.setOff}
    submitPressed={onConfirm}
  >
    <p style={{ color: Colors.neutral_500, fontSize: 16, textAlign: 'center' }}>
      This action will result in a charge to the office based on the price of the selected plan. Are
      you sure you want to continue?
    </p>
  </CustomPortal>
);
